import { getEvidenceDownloadURL } from '../routes';
import { Uuid } from 'common/common.types';

export default (id: number | Uuid) => getEvidenceDownloadURL(id);
